import { useEffect, useState } from "react";
import styles from "./Visitor.module.css";
import { getVisitorPublicaciones, getVisitorUser } from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import axios from "axios";
import { URL } from "../../link";
import VisitorJugador from "./VisitorJugador.jsx";
import VistorNoJugador from "./VistorNoJugador.jsx";
import Loading from "../Loading/Loading.jsx";

const Visitor = ({
  inVisitor,
  notificacionesBool,
  desactivarNotificacion,
  userBool,
  noticias,
  publicacionView,
  seguir,
  isMobile
}) => {
  const params = useParams();
  const id = params.id;
  const dispatch = useDispatch();
  const detailUser = useSelector((state) => state.dataVisitorUser);
  const publicaciones = useSelector((state) => state.visitorPublicaciones);
  const [entrenamientos, setEntrenamientos] = useState([]);

  const [scores, setScores] = useState([]);
  const [metricas, setMetricas] = useState([])

  console.log("isMobile", isMobile);

  const getScores = async () => {
    try {
      if(detailUser.rol === "Jugador") {
        const response = await axios.get(`${URL}/score/${detailUser.id}`);
        setScores(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getMetricas = async () => {
    try {
        const response = await axios.get(`${URL}/metrica/user/${detailUser.id}`)
        setMetricas(response.data.Metricas)
    } catch (error) {
        console.log(error)
    }
  }

  const getEntrenamientos = async () => {
    try {
      const response = await axios.get(`${URL}/entrenamiento/user/${id}`);
      setEntrenamientos(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(getVisitorUser(id));
    dispatch(getVisitorPublicaciones(id));
    getEntrenamientos();
    getScores();
    getMetricas();
  }, [dispatch, id]);

  // Mostrar loading mientras se cargan los datos del usuario
  if (!detailUser || !detailUser.id) {
    return <Loading />;
  }

  return (
    <div className={styles.containerVistor}>
      {detailUser.rol === "Jugador" ? (
        <VisitorJugador inVisitor={inVisitor} notificacionesBool={notificacionesBool} desactivarNotificacion={desactivarNotificacion} userBool={userBool} noticias={noticias} publicacionView={publicacionView} seguir={seguir} isMobile={isMobile}/>
      ) : (
        <VistorNoJugador inVisitor={inVisitor} notificacionesBool={notificacionesBool} desactivarNotificacion={desactivarNotificacion} userBool={userBool} noticias={noticias} publicacionView={publicacionView} seguir={seguir} isMobile={isMobile}/>
      )}
    </div>
  );
};

export default Visitor;
